"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateProfessionalExperienceDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const validate_date_1 = require("../../../../../service-lib/src/lib/utils/validate-date");
class CreateProfessionalExperienceDto {
}
exports.CreateProfessionalExperienceDto = CreateProfessionalExperienceDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "From date should be a date." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "From date must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (0, validate_date_1.validatePastDate)(value, "fromDate ")),
    tslib_1.__metadata("design:type", String)
], CreateProfessionalExperienceDto.prototype, "fromDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "To date should be a date." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "To date must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (0, validate_date_1.validatePastDate)(value, "toDate ")),
    tslib_1.__metadata("design:type", String)
], CreateProfessionalExperienceDto.prototype, "toDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Company name must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Company name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateProfessionalExperienceDto.prototype, "company", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Designation must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Designation must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateProfessionalExperienceDto.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Department must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Department must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateProfessionalExperienceDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Details must be a string" }),
    (0, class_validator_1.MaxLength)(500, { message: "Details must not exceed 500 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateProfessionalExperienceDto.prototype, "details", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateProfessionalExperienceDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateProfessionalExperienceDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateProfessionalExperienceDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateProfessionalExperienceDto.prototype, "updatedAt", void 0);
